$ = require 'jquery'
Controller = require 'app/scripts/controller'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'

{ TeamlessCollaborationPrompt } = require 'app/src/components/TeamlessCollaborationPrompt'
{ WorkspacesPreambleBoardHeaderButton, WorkspacesPreambleBoardInviteButton } = require 'app/src/components/WorkspacesPreamble'
{ featureFlagClient } = require '@trello/feature-flag-client'
Auth = require 'app/scripts/db/auth'
{ renderComponent } = require 'app/src/components/ComponentWrapper'

module.exports.onTeamCreatedFromCollaborationPrompt = (orgName) ->
  Controller.organizationBoardsView(orgName, { shouldShowTeamfulCollaborationPrompt: true })
    .then(=> @unmountTeamlessCollaborationPrompt())

module.exports.unmountTeamlessCollaborationPrompt = ->
  teamlessCollaborationPromptDiv = @$("#teamless-collaboration-prompt-target")[0]
  if teamlessCollaborationPromptDiv
    ReactDOM.unmountComponentAtNode(teamlessCollaborationPromptDiv)

  # We want to make sure that we aren't displaying
  # the invite acceptance popover at the same time
  @isPopoverRendered = false

module.exports.renderTeamlessCollaborationPrompt = ->
  teamlessCollaborationPromptDiv = @$("#teamless-collaboration-prompt-target")[0]
  workspacesPreambleFlagEnabled = featureFlagClient.get('btg.workspaces-preamble', false)
  hasDismissedTeamlessCollaborationPrompt = Auth.me().isDismissed("TeamlessCollaborationPrompt-#{@model.id}")
  if !teamlessCollaborationPromptDiv || workspacesPreambleFlagEnabled || hasDismissedTeamlessCollaborationPrompt || @hasSeenTeamlessCollaborationPrompt
    return

  @hasSeenTeamlessCollaborationPrompt = true
  renderComponent(
    React.createElement(
      TeamlessCollaborationPrompt,
      {
        boardId: @model.id,
        onClose: => @unmountTeamlessCollaborationPrompt(),
        onTeamCreated: (orgName) => @onTeamCreatedFromCollaborationPrompt(orgName),
        target: => @$('.js-add-board-to-team')[0]
      }
    ),
    teamlessCollaborationPromptDiv
  )

module.exports.unmountWorkspacesPreambleBoardHeaderButton = ->
  if @workspacesPreambleBoardHeaderButtonTarget
    ReactDOM.unmountComponentAtNode(@workspacesPreambleBoardHeaderButtonTarget)
    @workspacesPreambleBoardHeaderButtonTarget = null

module.exports.onWorkspacesPreambleCreateTeamSuccess = (orgName) ->
  if orgName
    Controller.organizationBoardsView(orgName, { shouldShowTeamfulCollaborationPrompt: true })
      .then(=> @unmountWorkspacesPreambleBoardHeaderButton())

module.exports.renderWorkspacesPreambleBoardHeaderButton = ->
  @unmountWorkspacesPreambleBoardHeaderButton()
  @workspacesPreambleBoardHeaderButtonTarget = @$('#workspaces-preamble-board-header-button')[0]

  if @workspacesPreambleBoardHeaderButtonTarget
    renderComponent(
      React.createElement(WorkspacesPreambleBoardHeaderButton, {
        boardId: @model.id,
        canAutoShow: !@workspacesPreamblePromptHasBeenSeen,
        onCreateTeamSuccess: (orgName) => @onWorkspacesPreambleCreateTeamSuccess(orgName)
      }),
      @workspacesPreambleBoardHeaderButtonTarget
    )
    @workspacesPreamblePromptHasBeenSeen = true

  return

module.exports.unmountWorkspacesPreambleInviteButton = ->
  if @workspacesPreambleInviteButtonTarget
    ReactDOM.unmountComponentAtNode(@workspacesPreambleInviteButtonTarget)

module.exports.renderWorkspacesPreambleInviteButton = ->
  @unmountWorkspacesPreambleInviteButton()
  @workspacesPreambleInviteButtonTarget = @$('#workspaces-preamble-invite-button')[0]

  if @workspacesPreambleInviteButtonTarget
    renderComponent(
      React.createElement(WorkspacesPreambleBoardInviteButton, {
        boardId: @model.id,
        onSuccess: =>
          @hasAddedBoardToTeamViaInviteButton = true
      }),
      @workspacesPreambleInviteButtonTarget
    )

    if @hasAddedBoardToTeamViaInviteButton
      @hasAddedBoardToTeamViaInviteButton = false
      @openAddMembers()

  return
